import { render, staticRenderFns } from "./PhoneChangeDialog.vue?vue&type=template&id=567a84ac&scoped=true&"
import script from "./PhoneChangeDialog.vue?vue&type=script&lang=js&"
export * from "./PhoneChangeDialog.vue?vue&type=script&lang=js&"
import style0 from "./PhoneChangeDialog.vue?vue&type=style&index=0&id=567a84ac&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "567a84ac",
  null
  
)

export default component.exports